import { LmiContractConfig, QualificationType } from './types';

export const njLmiContractConfig: LmiContractConfig = {
  title: 'Check if you qualify for income-based savings',
  description:
    'You may qualify for additional savings if your household income falls below a certain limit or if you participate in a qualifying low-to-moderate income (LMI) program.',
  lmiProofCategory: 'qualifying_programs',

  fields: [
    {
      name: 'county',
      type: 'select',
      label: 'County',
      required: false,
      placeholder: 'Select county',
    },
    {
      name: 'householdOccupancy',
      type: 'select',
      label: 'Household occupancy',
      required: true,
      placeholder: 'Select an option',
    },
    {
      name: 'qualifyingProgram',
      type: 'select',
      label: 'Select qualifying program (if applicable)',
      required: false,
      placeholder: 'Select program',
    },
    {
      name: 'qualificationType',
      type: 'radio',
      label: 'Please select one of the options below:',
      required: true,
      options: [
        {
          value: QualificationType.INCOME,
          label:
            "I, {customerName}, attest that my household's income for the previous calendar year is less than my county's household income limit of {incomeLimit}.",
          enableWhen: {
            allOf: ['county', 'householdOccupancy'],
          },
          interpolations: {
            incomeLimit: {
              source: 'variable',
              variableName: 'incomeLimit',
            },
            customerName: {
              source: 'variable',
              variableName: 'customerName',
            },
          },
        },
        {
          value: QualificationType.PROGRAM,
          label:
            'I, {customerName}, attest that the Qualifying Program which I participate in or receive benefits from is: {programName}.',
          enableWhen: {
            allOf: ['householdOccupancy', 'qualifyingProgram'],
          },
          interpolations: {
            programName: {
              source: 'field',
              fieldName: 'qualifyingProgram',
            },
            customerName: {
              source: 'variable',
              variableName: 'customerName',
            },
          },
        },
      ],
    },
  ],

  contractLink: {
    preText: 'I have reviewed my',
    postText: '. By proceeding, I will be submitting my e-signature on the',
  },
};
